<template>
  <header class="modal-card-head">
    <nav class="level is-title">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title modal-card-head__title">
            <span class="scope" v-t="`${langRoot}.title`"/>
          </h1>
        </div>
      </div>

      <div class="level-right">
        <div class="level-item"/>
      </div>
    </nav>
  </header>
</template>

<script>
const name = 'passwordreset-header';
export default {
    name,
    componentName: name,

    props: {
        langRoot: { type: String, required: true },
    },

    data() {
        return {};
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/PasswordResetHeader.vue